export default __webpack_public_path__ + "static/lsa-website-3-mobile-e0d8a0f4a894b61382281c445e1fb4a5.jpg";